import React, { Component } from 'react'
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import Formsy from 'formsy-react'
import { Grid } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addValidationRule } from 'formsy-react';
import queryString from 'query-string';
import { setAuthState } from '../../store/actions/actions';
import { loginSeller } from '../../services/auth';
import fieldEmailIcon from '../../assets/images/newui/field-email-icon.png'
import fieldPasswordIcon from '../../assets/images/newui/field-password-icon.png'
import './SignInContainerNew.less'
import { isNotBlankString } from 'helpers/validation';
import { getProfile, getTOSInfo } from '../../services/Seller';
import { setSellerProfileCompleted, setTOSSigned } from '../../store/actions/seller';
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';
import { pageView } from '../../common/analytics'
import { NavigationUrls } from '../../constants/NavigationUrls';

const initialState = {
    loading: false,
    email: '',
    password: '',
    errorMsg: '',
    windowWidth: 0,
}

addValidationRule('isNotBlankString', isNotBlankString);


class SignInContainerNew extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
       
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        pageView('/signin', 'Sign In');
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handlePhoneChange = (e, { value }) => {

        this.setState({ cellnumber: format(value) });

    }


    onValidSigninSubmit = async () => {
        try {
            const { email, password } = this.state;
            this.setState({ isLoading: true });
            loginSeller(email, password).then(async(res) => {
                if (!res.error) {
                    this.props.setAuthState(true, res.data, '');
                    const isSeller = res.data?.Seller ? true : false;
                    const sellerDriver = res.data?.SellerDriver;
                    this.setState({ loading: false });
                    if(isSeller) {
                        const profileResponse = await getProfile();
                        if(profileResponse.resStatus === 200){
                            const profile = profileResponse.data;
                            
                            if(!profile.isProfileCompleted){
                                this.props.history.push('/complete-profile');
                                return;
                            }
                            this.props.setSellerProfileCompleted(true);
                            const path = await this.checkTOSSigned();
                            if(path){
                                this.props.history.push(path);
                                return;
                            }
                            
                            const queryParams = queryString.parse(this.props.location.search);
                            const redirectTo = queryParams.originalUrl || `/`;//`${NavigationUrls.OPEN_REQUESTS}`;
                            
                            this.props.history.push(redirectTo);
                        }
                    }else if (sellerDriver) {

                            if (!sellerDriver.isInviteAccepted) {
                                this.props.history.push(NavigationUrls.DRIVER_INVITE_ACCEPTANCE);
                                return;
                            }
                            const queryParams = queryString.parse(this.props.location.search);
                            const redirectTo = queryParams.originalUrl || `/`;//`${NavigationUrls.OPEN_REQUESTS}`;      
                            this.props.history.push(redirectTo);
                    }         
                }else
                {
                    this.setState({ errorMsg:  res.error})
                }
            });

            // const response = await login(email, password);
            // if (response.resStatus >= 400) {
            //     this.setState({ errorMsg: response.message || 'Error while login.' })
            // }
            // if (response.resStatus == 200) {
            //     const authRes = await validateSellerAuthorization();
            //     if (authRes.resStatus >= 400) {
            //         this.setState({ errorMsg: authRes.message || 'Error while login.' })
            //     }
            //     else if (authRes.resStatus == 200){
                    
                    
            //         this.props.setAuthState(true, authRes.data.user, '');
                    
            //         this.setState({ loading: false });
            //         const profileResponse = await getProfile();
            //         if(profileResponse.resStatus === 200){
            //             const profile = profileResponse.data;
                        
            //             if(!profile.isProfileCompleted){
            //                 this.props.history.push('/complete-profile');
            //                 return;
            //             }
            //         }
            //         this.props.setSellerProfileCompleted(true);
    
            //         const queryParams = queryString.parse(this.props.location.search);
            //         const redirectTo = queryParams.originalUrl || `${NavigationUrls.OPEN_REQUESTS}`;
                    
            //         this.props.history.push(redirectTo);
            //     }

                
            // }
        } catch (error) {
            this.setState({ loading: false });
        }
    };

    checkTOSSigned = async() =>{
        if(this.props.isTOSEnabled)
        {
            const tosResponse = await getTOSInfo();
            if (!_.isNull(tosResponse) && !_.isEmpty(tosResponse.data)) {
                const tos = tosResponse.data;
                return `/agreement/${tos.catSEOName}`;
            }
            else{
                this.props.setTOSSigned(true);
            }
        }else
        {
            this.props.setTOSSigned(true);
        }
    }

    redirectToAppStore = () => {
        window.open('http://itunes.apple.com/app/id1481417514', '_blank');
    }

    // redirectToSignUp = () => {
    //     this.props.history.push('/business/signup');
    // }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        return (
            <div className='small-form-container'>
                <img src={servicegrace} />
                <div className='small-form-heading'>ServiceGrace</div>
                <div className='small-form-sub-heading'>Always Having Access To Customers</div>
                {this.state.errorMsg && <GeneralMessage message={this.state.errorMsg} type='error' />}
                
                <Formsy onValidSubmit={this.onValidSigninSubmit} className='small-form-form'>
                    <Grid>
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                            <DGTextbox name="email" label="Email" placeholder="Ex: example@email.com" required type="email"
                                tabIndex={3}
                                icon={fieldEmailIcon}
                                maxLength={100}
                                validations={{
                                    isEmail: true,
                                    maxLength: 100
                                }}
                                validationErrors={{
                                    isDefaultRequiredValue: 'This field is required',
                                    maxLength: 'Email should not exceed 100 characters.',
                                    isEmail: 'Enter a valid email.'
                                }}
                                onChange={this.handleChange}
                            />


                        </Grid.Column>


                        <Grid.Column mobile={16} tablet={16} computer={16}>
                            <DGTextbox name="password" label="Password" placeholder="" required type="password"
                                tabIndex={4}
                                icon={fieldPasswordIcon}
                                maxLength={100}

                                validationErrors={{
                                    isDefaultRequiredValue: 'This field is required',


                                }}
                                onChange={this.handleChange}
                            />


                        </Grid.Column>
                        <div className="small-form-link-container">
                            <div className="link"
                                onClick={() => this.props.history.push({
                                    pathname: '/reset-password-request'
                                })}>Forgot Password?</div>

                        </div>
                        <button className='small-form-submit' tabIndex={6} type='submit'>Login <img src={next} /></button>

                    </Grid>
                </Formsy>
            </div>

        )
    }
}

function mapStateToProps({ seller,reducer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        seller: seller,
        isTOSEnabled: reducer.isTOSEnabled
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState: setAuthState,
        setSellerProfileCompleted: setSellerProfileCompleted,
        setTOSSigned: setTOSSigned
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInContainerNew);

